import { useQuery } from "@apollo/client";
import { GetItemMaterialsByIdsDocument } from "../../gql/generated/graphql";

export const useItemMaterials = ({ ids }: { ids: string[] }) => {
  const { data, loading, error } = useQuery(GetItemMaterialsByIdsDocument, {
    variables: { ids },
  });

  return {
    itemMaterials: data?.getItemMaterialsByIds ?? [],
    isLoading: loading,
    error,
  };
};
